import styled, { css } from 'styled-components';

interface LabelWrapperProps {
  $translateTo: number;
  $width: number;
}
export const LabelWrapper = styled('div')<LabelWrapperProps>`
  transform: ${({ $translateTo }) => `translateX(${$translateTo}px)`};
  width: ${({ $width }) => $width + '%'};
  padding: 2px 0 2px ${({ theme }) => theme.x1spacePx}px;
`;

interface PeerNameWrapperProps {
  $minWidth: string;
  $width: string;
}
export const LabelNameWrapper = styled('div')<PeerNameWrapperProps>`
  min-width: ${({ $minWidth }) => $minWidth};
  width: ${({ $width }) => $width};
  white-space: nowrap;
`;

interface TickerLabelProps {
  selected?: boolean;
  hasBackground?: boolean;
  width: string;
}
export const LabelText = styled('div')<TickerLabelProps>`
  ${({ hasBackground, selected, theme }) =>
    hasBackground &&
    css`
      background: linear-gradient(
        270deg,
        ${selected ? theme.color.chart01 : theme.color.charcoalRGBA(0.8)} 0%,
        ${selected ? theme.color.chart01 : theme.color.charcoalRGBA(0.5)} 100%
      );
    `}
  padding: 0 6px;
  border-radius: 4px;
  width: ${({ width }) => width};
  margin-top: 2px;
`;
